module.exports = __webpack_public_path__ + "6fdfd4ff.svg";